/**
 * CrashCoursePage.tsx
 * -------------------
 * Page wrapper for the crash course stepper.
 */


import Layout from '../../components/common/Layout';
import CrashCourseStep from '../../components/CrashCourse/CrashCourseStep';

const CrashCoursePage = () => {
  return (
    <Layout>
      <CrashCourseStep />
    </Layout>
  );
};

export default CrashCoursePage;
